import { RouterProvider, createBrowserRouter } from 'react-router'
import { routes } from './routes'

/**
 * The real browser router (Task 11) — `StyleguideRoute` no longer renders
 * unconditionally as the whole app; it's one path among others in
 * `routes.tsx` now (`/styleguide`), reachable rather than default.
 *
 * `createBrowserRouter(routes)` at MODULE SCOPE, not inside this component's
 * body: the same reasoning `api/queryClient.ts`'s own doc comment states for
 * the query cache — v2 built its `QueryClient` in the `App` render body, so
 * every re-render minted a fresh one, and a router recreated on every
 * render would throw the same class of bug (losing navigation state, or
 * worse, on every parent re-render). `test/render.tsx` never imports this
 * file at all — it builds its OWN `createMemoryRouter(routes, ...)` for the
 * same `routes` table, which is what lets the test harness swap in a memory
 * history without this file's browser-only router ever being involved.
 */
const router = createBrowserRouter(routes)

export function App() {
  return <RouterProvider router={router} />
}
